export const START = 'start';
export const END = 'end';
export const CENTER = 'center';
